/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { createFetch } from '../../utils';
import FilterWithAuth from '../../components/FilterWithAuth';
import ModalSearchRow from './ModalSearchRow';
const { URL_PREFIX } = window;

const DeletedFieldName = [
    'LastModifiedDate', 'CreatedDate', 'attributes', 'LastModifiedById', 'CreatedById',
    'IsDeleted', 'MasterRecordId', 'SystemModstamp', 'LastActivityDate', 'LastViewedDate',
    'LastReferencedDate', 'OwnerId', 'LastReferencedDate', 'HasOverdueTask', 'HasOpenActivity',
    'RecordTypeId', 'Test__c', 'test', 'ID_Sandbox__c', 'Import__c',
];

class GuestDetail extends React.Component {
    constructor() {
        super();
        this.state = {
            selectedLayout: {},
            contactLayout: {},
            guestDetail: null,
            contactDetail: null,
            loading: false,
            editMode: false,
            changedGuestDetail: {},
            selectedSearchObject: '',
            selectedField: '',
            modalSearchShown: false,
        };
        this.save = this.save.bind(this);
        this.toggleHeading = this.toggleHeading.bind(this);
    }

    componentWillMount() {
        this.setState({ loading: true });
        this.getGuestDetail().then((guestDetail) => {
            console.log(guestDetail)
            Promise.all([
                this.getGuestLayout(),
                guestDetail.Guest_FullName__c && this.getContactDetail(guestDetail.Guest_FullName__c),
            ]).then((result) => {
                this.setState({ guestDetail, selectedLayout: result[0], contactDetail: result[1], loading: false });
            });
        });
    }

    async getContactDetail(contactId, forceRefresh = false) {
        const { user } = this.props;
        const result = await createFetch({
            path: `guest/contact/detail/${contactId}`,
            accessToken: user.accessToken,
            method: 'GET',
        });
        if (result.status === 200) {
            return result.record;
        }
        return null;
    }
    async getContactLayout() {
        const { user } = this.props;
        const result = await createFetch({
            path: 'salesforce/layout/Contact',
            accessToken: user.accessToken,
            method: 'GET',
        });
        if (result.status === 200) {
            return result.layout;
        }
        return {};
    }

    async getGuestLayout() {
        const { user } = this.props;
        const result = await createFetch({
            path: 'salesforce/layout/Guest__c',
            accessToken: user.accessToken,
            method: 'GET',
        });
        if (result.status === 200) {
            return result.layout;
        }
        return {};
    }

    async getGuestDetail(forceRefresh = false) {
        const { user } = this.props;
        const { id } = this.props.match.params;
        const result = await createFetch({
            path: `guest/detail/${id}?forceRefresh=${forceRefresh.toString()}`,
            accessToken: user.accessToken,
            method: 'GET',
        });
        if (result.status === 200) {
            return result.record;
        }
        return null;
    }

    changeFormValue(key, value, type = null) {
        if (['currency', 'double'].indexOf(type) > -1) {
            value = Array.isArray(value) ? value.join('') : null;
            if (!isNaN(parseFloat(value))) value = parseFloat(value);
        }
        let newValue = null;
        if (type === 'date') {
            newValue = moment(value).format('YYYY-MM-DD');
        }
        const { guestDetail, changedGuestDetail } = this.state;
        this.setState({
            guestDetail: {
                ...guestDetail,
                [key]: value,
            },
            changedGuestDetail: {
                ...changedGuestDetail,
                [key]: newValue || value,
            },
        });
    }


    printValue(guestDetail, component) {
        const { timezone } = this.props.user.info;
        if (!component.details) return '';
        let value = '';
        switch (component.details.type) {
        case 'reference':
            value = guestDetail[component.details.relationshipName] ? guestDetail[component.details.relationshipName].Name : null;
            break;
        case 'datetime':
            value = guestDetail[component.value] ? moment(guestDetail[component.value]).format('DD-MMM-YYYY hh:mm a') : '';
            break;
        case 'date':
            value = guestDetail[component.value] ? moment(guestDetail[component.value]).tz(timezone || 'Asia/Makassar').format('DD-MMM-YYYY') : '';
            break;
        case 'boolean':
            value = guestDetail[component.value] ? 'Yes' : 'No';
            break;
        case 'currency':
            value = guestDetail[component.value] ? `$ ${guestDetail[component.value].toLocaleString()}` : '$ 0';
            break;
        default:
            value = guestDetail[component.value];
            break;
        }

        return (
            <FilterWithAuth authRequired={[`oa:Guest__c:${component.value}`]}>
                {value}
            </FilterWithAuth>
        );
    }

    printEditable(guestDetail, component) {
        if (!component.details) return '';
        if (!component.details.updateable) return this.printValue(guestDetail, component);
        let input = null;
        switch (component.details.type) {
        case 'reference':
            input = (
                <div className="input-reference flex">
                    <input
                        type="text"
                        className="form-control"
                        onChange={e => this.changeFormValue(component.details.name, e.target.value, component.details.key)}
                        value={guestDetail[component.details.relationshipName] ? guestDetail[component.details.relationshipName].Name : guestDetail[component.details.name]}
                    />
                    <button
                        className="btn btn-primary btn-xs"
                        style={{ width: 40 }}
                        onClick={() => this.setState({
                            selectedField: component.details.name,
                            selectedSearchObject: component.details.referenceTo[0],
                            modalSearchShown: true,
                        })}
                    >
                        <i className="fa fa-search" />
                    </button>
                </div>
            );
            break;
        case 'datetime':
        case 'date':
            input = (
                <DatePicker
                    selected={guestDetail[component.details.name] ? new Date(guestDetail[component.details.name]) : null}
                    onChange={val => this.changeFormValue(component.details.name, val, component.details.type)}
                    dateFormat={component.details.type === 'datetime' ? 'dd-MMM-yyyy HH:mm' : 'dd-MMM-yyyy'}
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    yearDropdownItemNumber={80}
                    maxDate={new Date()}
                    showTimeSelect={component.details.type === 'datetime'}
                    timeFormat="HH:mm"
                />
            );
            break;
        case 'picklist':
            input = (
                <select
                    name={component.details.name}
                    className="form-control"
                    value={guestDetail[component.details.name]}
                    onChange={e => this.changeFormValue(component.details.name, e.target.value, component.details.type)}
                >
                    <option value="" />
                    {component.details.picklistValues.filter(o => o.active === true).map(picklist => (
                        <option value={picklist.value}>{picklist.label}</option>
                    ))}
                </select>
            );
            break;
        case 'boolean':
            input = (
                <div className="input-group flex checkbox">
                    <button
                        className={`btn btn-${guestDetail[component.details.name] ? 'success' : 'default'} active btn-sm`}
                        htmlFor="isDefault"
                        onClick={() => this.changeFormValue(component.details.name, !guestDetail[component.details.name], 'boolean')}
                        style={{
                            marginRight: 10, height: 25, width: 25, padding: 0,
                        }}
                    >
                        {guestDetail[component.details.name] ? <i className="fa fa-check" /> : <i className="fa" />}
                    </button>
                    Public
                </div>
            );
            break;
        case 'textarea':
            input = (
                <textarea
                    className="form-control"
                    row={5}
                    onChange={e => this.changeFormValue(component.details.name, e.target.value, component.details.type)}
                >
                    {guestDetail[component.details.name]}
                </textarea>
            );
            break;
        case 'currency':
        case 'double':
            input = (
                <React.Fragment>
                    <input
                        type="text"
                        className="form-control"
                        value={guestDetail[component.details.name]}
                        onChange={e => this.changeFormValue(component.details.name, e.target.value.match(/^\d*\.?\d+$/g), component.details.type)}
                    />
                    {guestDetail[component.details.name] && component.details.type === 'currency' ? guestDetail[component.details.name].toLocaleString('en', { style: 'currency', currency: 'USD' }) : ''}
                </React.Fragment>
            );
            break;
        default:
            input = (
                <React.Fragment>
                    <input
                        type="text"
                        className="form-control"
                        value={guestDetail[component.details.name]}
                        onChange={e => this.changeFormValue(component.details.name, e.target.value, component.details.type)}
                    />
                </React.Fragment>
            );
        }
        return (
            <FilterWithAuth authRequired={[`oa:Guest__c:${component.value}`]} isWriteAccess>
                {input}
            </FilterWithAuth>
        );
    }

    async save() {
        const { loading, changedGuestDetail, contactDetail } = this.state;
        if (loading) return;
        try {
            const { accessToken } = this.props.user;
            this.setState({ loading: true });
            const { id } = this.props.match.params;

            const promises = [];
            if (Object.keys(changedGuestDetail).length > 0) {
                promises.push(createFetch({
                    path: 'guest',
                    accessToken,
                    method: 'PATCH',
                    body: {
                        detail: {
                            ...changedGuestDetail,
                            Id: id,
                        },
                        objectName: 'Guest__c',
                    },
                }));
            }

            if (contactDetail && contactDetail.Id) {
                promises.push(createFetch({
                    path: `guest`,
                    accessToken,
                    method: 'PATCH',
                    body: {
                        detail : { 
                            Nationality__c: contactDetail.Nationality__c, 
                            Id: contactDetail.Id,
                         },
                        objectName: 'Contact',

                    },
                }));
            }

            const responses = await Promise.all(promises);

            const allSuccessful = responses.every(response => response.status === 200 || response.status === 204);

            if (allSuccessful) {
                Swal.fire({
                    backdrop: true,
                    type: 'success',
                    title: 'Succesfully updated',
                    text: 'This guest has been successfully updated',
                });
                this.setState({ loading: false, editMode: false });
                return;
            }

            const failedResponse = responses.find(response => response.status !== 200 && response.status !== 204);
            const error = new Error(failedResponse.message);
            error.validation = failedResponse.validation;
            throw error;
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                type: 'error',
                title: 'Failed to updated',
                text: error.message,
                backdrop: true,
            });
        }
    }

    toggleHeading(index, value) {
        const { selectedLayout } = this.state;
        selectedLayout.detailLayoutSections[index].collapsed = !value;
        this.setState({
            selectedLayout,
        });
    }

    render() {
        const {
            guestDetail, selectedLayout, contactLayout, contactDetail, loading, editMode, modalSearchShown, selectedSearchObject, selectedField,
        } = this.state;
        if (!selectedLayout || guestDetail === null) {
            return (
                <div className="guest-detail" id="guestDetail">
                    <i className="fa fa-spinner fa-spin fa-3x" />
                </div>
            );
        }
        const url = new URL(window.location.href);
        const viewId = url.searchParams.get('viewId');
        const date = url.searchParams.get('date');

        const guestObjDesc = this.props.objDesc.find(o => o.name === 'Guest__c');

        return (
            <div className="guest-detail" id="guestDetail">
                <Link to={`${URL_PREFIX}/app/guest-list/${date}?viewId=${viewId}`} className="">
                    <button
                        className="btn btn-info btn-sm"
                        type="button"
                    >
                        <i className="fa fa-arrow-left" /> Back
                    </button>
                </Link>
                <p style={{ color: '#000', fontSize: 18, margin: '20px 0 0' }}>Guest</p>
                <h2 className="fullName">{guestDetail.Guest_FullName__r ? guestDetail.Guest_FullName__r.Name : null}</h2>
                <div style={{ justifyContent: 'center', flex: 1, margin: '10px 0' }} className="flex">
                    {editMode ? (
                        <div className="btn-group" role="group">
                            <button
                                className="btn btn-default btn-sm"
                                type="button"
                                onClick={() => this.setState({ editMode: false })}
                            >
                                <i className="fa fa-times" /> Cancel
                            </button>
                            <button className="btn btn-success btn-sm" onClick={this.save}><i className="fa fa-save" /> Save</button>
                        </div>
                    ) : (
                        <div className="btn-group" role="group">
                            <FilterWithAuth authRequired={['oa:Guest__c']} isWriteAccess>
                                <button
                                    className="btn btn-warning btn-sm"
                                    type="button"
                                    onClick={() => this.setState({ editMode: true })}
                                >
                                    <i className="fa fa-edit" /> Edit
                                </button>
                            </FilterWithAuth>
                            <button
                                className="btn btn-info btn-sm"
                                type="button"
                                onClick={async () => {
                                    this.setState({ loading: true });
                                    await this.getGuestDetail(true);
                                    this.setState({ loading: false });
                                }}
                            >
                                <i className="fa fa-sync" /> Refresh
                            </button>
                        </div>
                    )
                    }
                </div>
                <p className="text-center">
                    {loading ? <i className="fa fa-circle-notch fa-spin fa-4x loading" /> : null}
                </p>
                {selectedLayout.detailLayoutSections.map((section, index) => (
                    <div className="section" key={section.layoutSectionId}>
                        <div className="section-header" onClick={() => { this.toggleHeading(index, section.collapsed); }}>
                            <h4>{section.heading}  <i className={`fa ${section.collapsed === true ? 'fa-caret-right' : 'fa-caret-down'}`} /></h4>
                        </div>
                        <div className={`section-content ${section.collapsed === true ? 'hide' : ''}`}>
                            {section.layoutRows.map(row => (
                                <div className="row flex" style={{ flexWrap: 'wrap' }}>
                                    {row.layoutItems.map((item) => {
                                        let isPrinted = true;
                                        item.layoutComponents.forEach((component) => {
                                            isPrinted = isPrinted && DeletedFieldName.indexOf(component.value) === -1;
                                        });
                                        return (item.layoutComponents.length === 0 || item.label === '' || isPrinted === false ?
                                            <div className="item" /> :
                                            (
                                                <div className="item">
                                                    <p className="item-label" data-item={JSON.stringify(item)}>{item.label}</p>
                                                    {/* <select
                                                                    className="form-control"
                                                                    value={contactDetail && contactDetail.Nationality__c}
                                                                    onChange={(e) => {
                                                                        const { contactDetail: currentContactDetail } = this.state;
                                                                        this.setState({
                                                                            contactDetail: {
                                                                                ...currentContactDetail,
                                                                                Nationality__c: e.target.value,
                                                                            },
                                                                        });
                                                                    }}
                                                                >
                                                                    <option value="" />
                                                                    {(() => {
                                                                        if (!contactLayout.editLayoutSections) return null;
                                                                        const contactNationalityField = contactLayout.editLayoutSections[0].layoutRows.map(row => row.layoutItems).flat().find(i => i.label === 'Nationality');
                                                                        if (!contactNationalityField) return null;
                                                                        const nationalityFieldDetails = contactNationalityField.layoutComponents[0].details;
                                                                        return nationalityFieldDetails.picklistValues.filter(o => o.active === true).map(picklist => (
                                                                            <option value={picklist.value}>{picklist.label}</option>
                                                                        ));
                                                                    })()}
                                                                </select>  */}
                                                    <p className="separator">:</p>
                                                    <p className={`value ${editMode ? 'edit' : ''}`}>
                                                        {item.label === 'Nationality' ?
                                                            !editMode ? (contactDetail && contactDetail.Nationality__c) :
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={(contactDetail && contactDetail.Nationality__c) || ''}
                                                                    onChange={(e) => {
                                                                        const { contactDetail: currentContactDetail } = this.state;
                                                                        this.setState({
                                                                            contactDetail: {
                                                                                ...currentContactDetail,
                                                                                Nationality__c: e.target.value,
                                                                            },
                                                                        });
                                                                    }}
                                                                /> :
                                                            item.layoutComponents.map(component => (
                                                                !editMode ? this.printValue(guestDetail, component) :
                                                                    this.printEditable(guestDetail, component)
                                                            ))}
                                                    </p>
                                                </div>
                                            )
                                        );
                                    })
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
                <ModalSearchRow
                    visible={modalSearchShown}
                    objectName={selectedSearchObject}
                    accessToken={this.props.user.accessToken}
                    onClose={() => this.setState({ modalSearchShown: false })}
                    onPick={(val) => {
                        const selectedFieldDesc = guestObjDesc.fields.find(o => o.name === selectedField);
                        this.setState({
                            guestDetail: {
                                ...guestDetail,
                                [selectedField]: val.Id,
                                [selectedFieldDesc.relationshipName]: {
                                    Name: val.Name,
                                },
                            },
                            changedGuestDetail: {
                                [selectedField]: val.Id,
                            },
                            modalSearchShown: false,
                        });
                    }}
                />
            </div>
        );
    }
}


GuestDetail.propTypes = {
    user: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    objDesc: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    objDesc: state.salesforce.objDesc,
});


export default connect(mapStateToProps, mapDispatchToProps)(GuestDetail);
